// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import Icon from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import messages from './messages.tsx';

export type Props = {
	readonly intl: IntlShape;
};

const arrowRightGlyph = (props: ComponentProps<'svg'>) => (
	<svg {...props} width="24" height="24" viewBox="0 0 24 24" focusable={false}>
		<path
			d="M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
);

const StatusFieldOld = () => {
	const { formatMessage } = useIntl();
	// we need an extra `div` wrapper here to deal with 100% width that comes from the parent element with display: flex
	// the status field should have auto width based on it's content
	// we can't use fixed width, because in different languages the field name can require different width
	return (
		<div>
			<StatusFieldWrapper>
				<Icon label="" glyph={arrowRightGlyph} size="medium" />
				{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
				<span>{formatMessage(messages.statusFieldName)}</span>
			</StatusFieldWrapper>
		</div>
	);
};

/**
 * The decision point of the StatusField component.
 * It renders the old implementation of the StatusField component.
 * In future implementation, this can be used to create the newer implementation of the StatusField component.
 * Hence this is being left as is.
 *
 * @returns {JSX.Element} StatusField component that switches between the old and new implementation
 */
const StatusField = () => {
	return <StatusFieldOld />;
};

export default StatusField;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StatusFieldWrapper = styled.div({
	display: 'inline flex',
	alignItems: 'center',
	gap: token('space.100'),
	border: `1px solid ${token('color.border')}`,
	marginBottom: token('space.050'),
	padding: token('space.100'),
	paddingRight: token('space.200'),
	boxSizing: 'border-box',
	borderRadius: '3px',
	backgroundColor: token('color.border.inverse'),
});
